import StyleButton from './StyleButton'

const InlineStyleControls = props => {
  var currentStyle = props.editorState.getCurrentInlineStyle()
  const { classes, inlineStyles, onToggle } = props

  const onMouseDown = event => {
    // Prevent focus stealing
    event.preventDefault()
  }

  if (inlineStyles) {
    return (
      <div className={classes.controls} onMouseDown={onMouseDown}>
        {inlineStyles.map(type => (
          <StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            onToggle={onToggle}
            style={type.style}
            classes={classes}
            icon={type.icon}
          />
        ))}
      </div>
    )
  } else {
    return null
  }
}

export default InlineStyleControls
